export default __webpack_public_path__ + "static/media/productHealthCheckPackage2_Cn.1e746ad2.webp";